import { createMuiTheme } from "@material-ui/core";
import { COLORS } from "../../utils/js/constants";

export default function stockStyle(theme) {
    return {
        listCopyButton: {
            color: COLORS.lightYellow,
            cursor: "pointer",
        },
        tableContainer: {
            backgroundColor: COLORS.grey,
            padding: theme.spacing(2),
            display: "flex",
            overflow: "auto",
            flexDirection: "column",
        },
        tableTitle: {
            color: COLORS.lightYellow
        }
    }
}

export const theme = createMuiTheme({
    overrides: {
        MuiTableCell: {
            head: {
                color: "rgb(255, 255, 255)",
                fontWeight: 700,
                letterSpacing: 1,
                textTransform: "uppercase",
            },
            root: {
                borderBottom: "solid 1px rgba(255, 255, 255,0.5)",
            },
            body: {
                color: COLORS.white,
            },
        },
        MuiTypography: {
            colorPrimary: {
                color: COLORS.lightYellow,
            },
        },
    },
});
